<li *ngIf="isVehiclesLoading" class="item-item flex-center-center pt-2 pb-2 pr-2 pl-2 pointer">
    <i class="fal fa-spinner font-18 rotate"></i>
</li>

<div *ngIf="!isVehiclesLoading" class="edit-vehicle-wrapper scrollable p-2">
    <div class="edit-vehicle-detail pt-4">
        <div class="order-customer-content flex-column width-100">
            <div class="d-flex justify-content-between width-100 pl-1 pr-1">
                <p class="header">{{'tech-app.vehicle-specification' | translate}}</p>
                <span class="close-btn" (click)="goBack()">
                    <img src="assets/img/icon/cross.svg" />
                </span>
            </div>

            <div class="data-container pl-3">

                <div *ngFor="let fluid of fluidSpecificationsArr1"
                    class="font-12 font-gray-35 fluid-specification-card mb-2 pt-1">
                    <span class="font-600 font-secondary-700 font-14">
                        {{ fluid.name }}
                    </span><br>
                    <span class="font-secondary-700 font-13">
                        {{ fluid.specs }}
                    </span>
                </div>
            </div>

            <div class="data-container pl-3">

                <div *ngFor="let fluid of fluidSpecificationsArr2"
                    class="font-12 font-gray-35 fluid-specification-card-small mb-2 pt-1">
                    <span class="font-600 font-secondary-700 font-14">
                        {{ fluid.name }}
                    </span><br>
                    <span class="font-secondary-700 font-13">
                        {{ fluid.specs }}
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="dummy-tech-iphone-height"></div>
</div>